module.exports = __webpack_public_path__ + "img/37.4c64a38a.jpg";